import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import {notify} from "@/plugins/notification";
import i18n from "@/i18n";


export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async payPlan({rootState}, params) {
            const {tier, billingPeriod, amountShops} = params;
            const url = URLS.PAY.CREATE_PAYMENT_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: rootState.personalData.role || "founder",
                },
                credentials: "include",
                body: JSON.stringify({
                    tier: tier,
                    billing_period: billingPeriod,
                    amount_shops: amountShops,
                }),
            };
            const successfulHandler = async (data) => {
                notify(i18n.global.t("Redirecting to the payment page..."), 3000);
                if (window.Capacitor?.isNativePlatform?.()) {
                    const {Browser} = await import('@capacitor/browser');
                    await Browser.open({url: data.data});
                } else {
                    window.location.href = data.data;
                }
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async goToFreePlan({commit, rootState}) {
            const url = URLS.PAY.GO_TO_FREE_PLAN_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: rootState.personalData.role || "founder",
                },
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("company/setCompanyData", data.data, {root: true});
                notify(i18n.global.t("You have been successfully switched to the free plan"))
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};